export default __webpack_public_path__ + "static/media/three.46c724b1.svg";